import React, { Component } from 'react'
import '../css/styles.css'
import { connect } from 'react-redux'
import { checkSecurityAnswer, fetchUsername, handlePrev } from '../redux/actions/forgotPasswordActions'
import { injectIntl } from 'react-intl'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import { localizeImg, localize } from '../util/Localizer'
import TopNav from '../widgets/common/TopNav'
import { Dimensions } from '../theme'
import { withStyles } from '@material-ui/core/styles'

// Our components//
import Username from '../widgets/ForgotPassword/Username'
import Question from '../widgets/ForgotPassword/Question'

class ForgotPassword extends Component {
  constructor () {
    super()
    this.renderCard = this.renderCard.bind(this)
    this.checkUser = this.checkUser.bind(this)
    this.checkAnswer = this.checkAnswer.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.state = {
      userName: '',
      noUserName: '',
      securityAnswer: '',
      noSecurityAnswer: ''
    }
  }

  renderCard () {
    if (this.props.isFirstScreen) {
      return (
        <Username
          checkUser={this.checkUser}
          error={this.props.error}
          handlePrev={this.props.handlePrev}
          loading={this.props.isLoading}
          handleInputChange={this.handleInputChange}
          values={this.state}
          disableButton={this.disableNext()} />
      )
    } else {
      return (
        <Question
          checkAnswer={this.checkAnswer}
          question={this.props.question}
          handlePrev={this.props.handlePrev}
          error={this.props.error}
          loading={this.props.isLoading}
          handleInputChange={this.handleInputChange}
          values={this.state}
          disableButton={this.disableNext()} />
      )
    }
  }

  checkUser (e) {
    e.preventDefault()
    const userName = document.getElementById('userName').value
    this.props.fetchUsername(userName)
  }

  checkAnswer (e) {
    e.preventDefault()
    const userName = this.props.userName
    const securityQuestion = this.props.question
    const securityAnswer = document.getElementById('securityAnswer').value
    this.props.checkSecurityAnswer(userName, securityQuestion, securityAnswer)
  }

  handleInputChange (event) {
    const state = this.state
    const targetId = event.target.id
    state[targetId] = event.target.value.trim()

    if (targetId === 'userName') {
      // check for username
      if (state.userName.length === 0) {
        state.noUserName = localize('error.account.login.noUsername')
      } else {
        state.noUserName = null
      }
    }

    if (targetId === 'securityAnswer') {
      // check for username
      if (state.securityAnswer.length === 0) {
        state.noSecurityAnswer = localize('error.account.forgotPassword.noSecurityAnswer')
      } else {
        state.noSecurityAnswer = null
      }
    }

    this.setState({ state })
  }

  disableNext () {
    const { isFirstScreen } = this.props
    if ((isFirstScreen && this.state.userName.length === 0) || (!isFirstScreen && this.state.securityAnswer.length === 0)) {
      return true
    }
    return false
  }

  render () {
    const { classes = {} } = this.props
    const logo = localizeImg('/img/logo.svg')
    return (
      <div className={classes.forgotPassPage}>
        <Grid fluid>
          <TopNav primary />
          <Row center='lg' className={classes.screenHeight}>
            <Col xs={12} md={6} lg={6} id='login'>
              <Paper className={classes.paper} elevation={2}>
                <img src={logo} alt={localize('pages.login.logoAlt')} />
                {this.renderCard()}
              </Paper>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    isFirstScreen: state.ForgotPasswordReducer.isFirstScreen,
    isLoading: state.ForgotPasswordReducer.isLoading,
    isDisabled: state.ForgotPasswordReducer.isDisabled,
    question: state.ForgotPasswordReducer.question,
    userName: state.ForgotPasswordReducer.userName,
    error: state.ForgotPasswordReducer.error

  }
}

const ConnectedForgotPassword = connect(mapStateToProps, {
  handlePrev,
  fetchUsername,
  checkSecurityAnswer })(injectIntl(ForgotPassword))

const styles = {
  forgotPassPage: {
    overflowY: 'scroll',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    '& img': {
      maxWidth: Dimensions.loginLogoMaxWidth
    },
    '& .userName': {
      marginBottom: 25
    }
  },
  paper: {
    width: '100%',
    padding: '45px 100px',
    textAlign: 'center',
    display: 'inline-block'
  },
  screenHeight: {
    minHeight: 'calc(100vh)'
  }
}

export default withStyles(styles)(ConnectedForgotPassword)



// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js